export enum ReferenceFeatureEnum {
    TECH_PACK = 'TECH PACK'
}